
const list = {
  path: 'list/:pages',
  component: resolve => require(['../../../../../pages/modules/knowledge/list'], resolve),
}

export default list
